// @generated by protobuf-ts 2.11.1 with parameter ts_nocheck
// @generated from protobuf file "tracks.proto" (package "tpg", syntax proto3)
// tslint:disable
// @ts-nocheck
import { Empty } from "./google/protobuf/empty";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message tpg.HealthCheckResponse
 */
export interface HealthCheckResponse {
    /**
     * @generated from protobuf field: tpg.ServingStatus status = 1
     */
    status: ServingStatus;
}
/**
 * @generated from protobuf message tpg.SubscribeRequest
 */
export interface SubscribeRequest {
    /**
     * @generated from protobuf field: string subscriber_id = 1
     */
    subscriberId: string;
    /**
     * @generated from protobuf field: string device_id = 2
     */
    deviceId: string;
}
/**
 * @generated from protobuf message tpg.PingRequest
 */
export interface PingRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string timestamp = 2
     */
    timestamp: string;
}
/**
 * @generated from protobuf message tpg.ConnectedEvent
 */
export interface ConnectedEvent {
    /**
     * @generated from protobuf field: string subscriber_id = 1
     */
    subscriberId: string;
    /**
     * @generated from protobuf field: string server_timestamp = 2
     */
    serverTimestamp: string;
    /**
     * @generated from protobuf field: string connection_id = 3
     */
    connectionId: string;
    /**
     * @generated from protobuf field: string device_id = 4
     */
    deviceId: string;
    /**
     * @generated from protobuf field: int32 ping_interval_ms = 5
     */
    pingIntervalMs: number;
    /**
     * @generated from protobuf field: int32 ping_timeout_ms = 6
     */
    pingTimeoutMs: number;
}
/**
 * @generated from protobuf message tpg.PingEvent
 */
export interface PingEvent {
    /**
     * @generated from protobuf field: string connection_id = 1
     */
    connectionId: string;
    /**
     * @generated from protobuf field: string timestamp = 2
     */
    timestamp: string;
}
/**
 * @generated from protobuf message tpg.PongEvent
 */
export interface PongEvent {
    /**
     * @generated from protobuf field: string connection_id = 1
     */
    connectionId: string;
    /**
     * @generated from protobuf field: string timestamp = 2
     */
    timestamp: string;
}
/**
 * @generated from protobuf message tpg.SubscribeEvent
 */
export interface SubscribeEvent {
    /**
     * @generated from protobuf oneof: payload
     */
    payload: {
        oneofKind: "position";
        /**
         * @generated from protobuf field: tpg.PositionResponse position = 1
         */
        position: PositionResponse;
    } | {
        oneofKind: "connected";
        /**
         * @generated from protobuf field: tpg.ConnectedEvent connected = 2
         */
        connected: ConnectedEvent;
    } | {
        oneofKind: "ping";
        /**
         * @generated from protobuf field: tpg.PingEvent ping = 3
         */
        ping: PingEvent;
    } | {
        oneofKind: "pong";
        /**
         * @generated from protobuf field: tpg.PongEvent pong = 4
         */
        pong: PongEvent;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message tpg.AddSubscriptionRequest
 */
export interface AddSubscriptionRequest {
    /**
     * @generated from protobuf field: string subscriber_id = 1
     */
    subscriberId: string;
    /**
     * @generated from protobuf field: repeated string producer_ids = 2
     */
    producerIds: string[];
}
/**
 * @generated from protobuf message tpg.RemoveSubscriptionRequest
 */
export interface RemoveSubscriptionRequest {
    /**
     * @generated from protobuf field: string subscriber_id = 1
     */
    subscriberId: string;
    /**
     * @generated from protobuf field: repeated string producer_ids = 2
     */
    producerIds: string[];
}
/**
 * @generated from protobuf message tpg.SubscriptionResponse
 */
export interface SubscriptionResponse {
    /**
     * @generated from protobuf field: string subscriber_id = 1
     */
    subscriberId: string;
    /**
     * @generated from protobuf field: repeated string producer_ids = 2
     */
    producerIds: string[];
}
/**
 * @generated from protobuf message tpg.PositionRequest
 */
export interface PositionRequest {
    /**
     * @generated from protobuf field: string position_id = 1
     */
    positionId: string;
    /**
     * @generated from protobuf field: string producer_id = 2
     */
    producerId: string;
    /**
     * @generated from protobuf field: double latitude = 3
     */
    latitude: number;
    /**
     * @generated from protobuf field: double longitude = 4
     */
    longitude: number;
    /**
     * @generated from protobuf field: float location_accuracy = 5
     */
    locationAccuracy: number;
    /**
     * @generated from protobuf field: float heading = 6
     */
    heading: number;
    /**
     * @generated from protobuf field: float altitude = 7
     */
    altitude: number;
    /**
     * @generated from protobuf field: float altitude_accuracy = 8
     */
    altitudeAccuracy: number;
    /**
     * @generated from protobuf field: float speed = 9
     */
    speed: number;
    /**
     * @generated from protobuf field: string client_timestamp = 10
     */
    clientTimestamp: string;
    /**
     * @generated from protobuf field: map<string, string> properties = 12
     */
    properties: {
        [key: string]: string;
    };
}
/**
 * @generated from protobuf message tpg.PositionResponse
 */
export interface PositionResponse {
    /**
     * @generated from protobuf field: string position_id = 1
     */
    positionId: string;
    /**
     * @generated from protobuf field: string producer_id = 2
     */
    producerId: string;
    /**
     * @generated from protobuf field: double latitude = 3
     */
    latitude: number;
    /**
     * @generated from protobuf field: double longitude = 4
     */
    longitude: number;
    /**
     * @generated from protobuf field: float location_accuracy = 5
     */
    locationAccuracy: number;
    /**
     * @generated from protobuf field: float heading = 6
     */
    heading: number;
    /**
     * @generated from protobuf field: float altitude = 7
     */
    altitude: number;
    /**
     * @generated from protobuf field: float altitude_accuracy = 8
     */
    altitudeAccuracy: number;
    /**
     * @generated from protobuf field: float speed = 9
     */
    speed: number;
    /**
     * @generated from protobuf field: string client_timestamp = 10
     */
    clientTimestamp: string;
    /**
     * @generated from protobuf field: string server_timestamp = 11
     */
    serverTimestamp: string;
    /**
     * @generated from protobuf field: map<string, string> properties = 12
     */
    properties: {
        [key: string]: string;
    };
}
/**
 * @generated from protobuf message tpg.BulkPositionRequest
 */
export interface BulkPositionRequest {
    /**
     * @generated from protobuf field: repeated tpg.PositionRequest positions = 1
     */
    positions: PositionRequest[];
}
/**
 * @generated from protobuf message tpg.BulkPositionResponse
 */
export interface BulkPositionResponse {
    /**
     * @generated from protobuf field: repeated tpg.PositionResponse positions = 1
     */
    positions: PositionResponse[];
}
/**
 * @generated from protobuf enum tpg.ServingStatus
 */
export enum ServingStatus {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: SERVING = 1;
     */
    SERVING = 1,
    /**
     * @generated from protobuf enum value: NOT_SERVING = 2;
     */
    NOT_SERVING = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class HealthCheckResponse$Type extends MessageType<HealthCheckResponse> {
    constructor() {
        super("tpg.HealthCheckResponse", [
            { no: 1, name: "status", kind: "enum", T: () => ["tpg.ServingStatus", ServingStatus] }
        ]);
    }
    create(value?: PartialMessage<HealthCheckResponse>): HealthCheckResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.status = 0;
        if (value !== undefined)
            reflectionMergePartial<HealthCheckResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HealthCheckResponse): HealthCheckResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* tpg.ServingStatus status */ 1:
                    message.status = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HealthCheckResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* tpg.ServingStatus status = 1; */
        if (message.status !== 0)
            writer.tag(1, WireType.Varint).int32(message.status);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tpg.HealthCheckResponse
 */
export const HealthCheckResponse = new HealthCheckResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SubscribeRequest$Type extends MessageType<SubscribeRequest> {
    constructor() {
        super("tpg.SubscribeRequest", [
            { no: 1, name: "subscriber_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "device_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SubscribeRequest>): SubscribeRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.subscriberId = "";
        message.deviceId = "";
        if (value !== undefined)
            reflectionMergePartial<SubscribeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SubscribeRequest): SubscribeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string subscriber_id */ 1:
                    message.subscriberId = reader.string();
                    break;
                case /* string device_id */ 2:
                    message.deviceId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SubscribeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string subscriber_id = 1; */
        if (message.subscriberId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.subscriberId);
        /* string device_id = 2; */
        if (message.deviceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.deviceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tpg.SubscribeRequest
 */
export const SubscribeRequest = new SubscribeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PingRequest$Type extends MessageType<PingRequest> {
    constructor() {
        super("tpg.PingRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "timestamp", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PingRequest>): PingRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.timestamp = "";
        if (value !== undefined)
            reflectionMergePartial<PingRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PingRequest): PingRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string timestamp */ 2:
                    message.timestamp = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PingRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string timestamp = 2; */
        if (message.timestamp !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.timestamp);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tpg.PingRequest
 */
export const PingRequest = new PingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectedEvent$Type extends MessageType<ConnectedEvent> {
    constructor() {
        super("tpg.ConnectedEvent", [
            { no: 1, name: "subscriber_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "server_timestamp", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "connection_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "device_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "ping_interval_ms", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "ping_timeout_ms", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ConnectedEvent>): ConnectedEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.subscriberId = "";
        message.serverTimestamp = "";
        message.connectionId = "";
        message.deviceId = "";
        message.pingIntervalMs = 0;
        message.pingTimeoutMs = 0;
        if (value !== undefined)
            reflectionMergePartial<ConnectedEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectedEvent): ConnectedEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string subscriber_id */ 1:
                    message.subscriberId = reader.string();
                    break;
                case /* string server_timestamp */ 2:
                    message.serverTimestamp = reader.string();
                    break;
                case /* string connection_id */ 3:
                    message.connectionId = reader.string();
                    break;
                case /* string device_id */ 4:
                    message.deviceId = reader.string();
                    break;
                case /* int32 ping_interval_ms */ 5:
                    message.pingIntervalMs = reader.int32();
                    break;
                case /* int32 ping_timeout_ms */ 6:
                    message.pingTimeoutMs = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectedEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string subscriber_id = 1; */
        if (message.subscriberId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.subscriberId);
        /* string server_timestamp = 2; */
        if (message.serverTimestamp !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.serverTimestamp);
        /* string connection_id = 3; */
        if (message.connectionId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.connectionId);
        /* string device_id = 4; */
        if (message.deviceId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.deviceId);
        /* int32 ping_interval_ms = 5; */
        if (message.pingIntervalMs !== 0)
            writer.tag(5, WireType.Varint).int32(message.pingIntervalMs);
        /* int32 ping_timeout_ms = 6; */
        if (message.pingTimeoutMs !== 0)
            writer.tag(6, WireType.Varint).int32(message.pingTimeoutMs);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tpg.ConnectedEvent
 */
export const ConnectedEvent = new ConnectedEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PingEvent$Type extends MessageType<PingEvent> {
    constructor() {
        super("tpg.PingEvent", [
            { no: 1, name: "connection_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "timestamp", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PingEvent>): PingEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.connectionId = "";
        message.timestamp = "";
        if (value !== undefined)
            reflectionMergePartial<PingEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PingEvent): PingEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string connection_id */ 1:
                    message.connectionId = reader.string();
                    break;
                case /* string timestamp */ 2:
                    message.timestamp = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PingEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string connection_id = 1; */
        if (message.connectionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.connectionId);
        /* string timestamp = 2; */
        if (message.timestamp !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.timestamp);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tpg.PingEvent
 */
export const PingEvent = new PingEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PongEvent$Type extends MessageType<PongEvent> {
    constructor() {
        super("tpg.PongEvent", [
            { no: 1, name: "connection_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "timestamp", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PongEvent>): PongEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.connectionId = "";
        message.timestamp = "";
        if (value !== undefined)
            reflectionMergePartial<PongEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PongEvent): PongEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string connection_id */ 1:
                    message.connectionId = reader.string();
                    break;
                case /* string timestamp */ 2:
                    message.timestamp = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PongEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string connection_id = 1; */
        if (message.connectionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.connectionId);
        /* string timestamp = 2; */
        if (message.timestamp !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.timestamp);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tpg.PongEvent
 */
export const PongEvent = new PongEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SubscribeEvent$Type extends MessageType<SubscribeEvent> {
    constructor() {
        super("tpg.SubscribeEvent", [
            { no: 1, name: "position", kind: "message", oneof: "payload", T: () => PositionResponse },
            { no: 2, name: "connected", kind: "message", oneof: "payload", T: () => ConnectedEvent },
            { no: 3, name: "ping", kind: "message", oneof: "payload", T: () => PingEvent },
            { no: 4, name: "pong", kind: "message", oneof: "payload", T: () => PongEvent }
        ]);
    }
    create(value?: PartialMessage<SubscribeEvent>): SubscribeEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.payload = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<SubscribeEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SubscribeEvent): SubscribeEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* tpg.PositionResponse position */ 1:
                    message.payload = {
                        oneofKind: "position",
                        position: PositionResponse.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).position)
                    };
                    break;
                case /* tpg.ConnectedEvent connected */ 2:
                    message.payload = {
                        oneofKind: "connected",
                        connected: ConnectedEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).connected)
                    };
                    break;
                case /* tpg.PingEvent ping */ 3:
                    message.payload = {
                        oneofKind: "ping",
                        ping: PingEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).ping)
                    };
                    break;
                case /* tpg.PongEvent pong */ 4:
                    message.payload = {
                        oneofKind: "pong",
                        pong: PongEvent.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).pong)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SubscribeEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* tpg.PositionResponse position = 1; */
        if (message.payload.oneofKind === "position")
            PositionResponse.internalBinaryWrite(message.payload.position, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* tpg.ConnectedEvent connected = 2; */
        if (message.payload.oneofKind === "connected")
            ConnectedEvent.internalBinaryWrite(message.payload.connected, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* tpg.PingEvent ping = 3; */
        if (message.payload.oneofKind === "ping")
            PingEvent.internalBinaryWrite(message.payload.ping, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* tpg.PongEvent pong = 4; */
        if (message.payload.oneofKind === "pong")
            PongEvent.internalBinaryWrite(message.payload.pong, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tpg.SubscribeEvent
 */
export const SubscribeEvent = new SubscribeEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddSubscriptionRequest$Type extends MessageType<AddSubscriptionRequest> {
    constructor() {
        super("tpg.AddSubscriptionRequest", [
            { no: 1, name: "subscriber_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "producer_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AddSubscriptionRequest>): AddSubscriptionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.subscriberId = "";
        message.producerIds = [];
        if (value !== undefined)
            reflectionMergePartial<AddSubscriptionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AddSubscriptionRequest): AddSubscriptionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string subscriber_id */ 1:
                    message.subscriberId = reader.string();
                    break;
                case /* repeated string producer_ids */ 2:
                    message.producerIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AddSubscriptionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string subscriber_id = 1; */
        if (message.subscriberId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.subscriberId);
        /* repeated string producer_ids = 2; */
        for (let i = 0; i < message.producerIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.producerIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tpg.AddSubscriptionRequest
 */
export const AddSubscriptionRequest = new AddSubscriptionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveSubscriptionRequest$Type extends MessageType<RemoveSubscriptionRequest> {
    constructor() {
        super("tpg.RemoveSubscriptionRequest", [
            { no: 1, name: "subscriber_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "producer_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RemoveSubscriptionRequest>): RemoveSubscriptionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.subscriberId = "";
        message.producerIds = [];
        if (value !== undefined)
            reflectionMergePartial<RemoveSubscriptionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemoveSubscriptionRequest): RemoveSubscriptionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string subscriber_id */ 1:
                    message.subscriberId = reader.string();
                    break;
                case /* repeated string producer_ids */ 2:
                    message.producerIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RemoveSubscriptionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string subscriber_id = 1; */
        if (message.subscriberId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.subscriberId);
        /* repeated string producer_ids = 2; */
        for (let i = 0; i < message.producerIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.producerIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tpg.RemoveSubscriptionRequest
 */
export const RemoveSubscriptionRequest = new RemoveSubscriptionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SubscriptionResponse$Type extends MessageType<SubscriptionResponse> {
    constructor() {
        super("tpg.SubscriptionResponse", [
            { no: 1, name: "subscriber_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "producer_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SubscriptionResponse>): SubscriptionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.subscriberId = "";
        message.producerIds = [];
        if (value !== undefined)
            reflectionMergePartial<SubscriptionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SubscriptionResponse): SubscriptionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string subscriber_id */ 1:
                    message.subscriberId = reader.string();
                    break;
                case /* repeated string producer_ids */ 2:
                    message.producerIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SubscriptionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string subscriber_id = 1; */
        if (message.subscriberId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.subscriberId);
        /* repeated string producer_ids = 2; */
        for (let i = 0; i < message.producerIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.producerIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tpg.SubscriptionResponse
 */
export const SubscriptionResponse = new SubscriptionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PositionRequest$Type extends MessageType<PositionRequest> {
    constructor() {
        super("tpg.PositionRequest", [
            { no: 1, name: "position_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "producer_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "latitude", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "longitude", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "location_accuracy", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 6, name: "heading", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 7, name: "altitude", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 8, name: "altitude_accuracy", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 9, name: "speed", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 10, name: "client_timestamp", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "properties", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } }
        ]);
    }
    create(value?: PartialMessage<PositionRequest>): PositionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.positionId = "";
        message.producerId = "";
        message.latitude = 0;
        message.longitude = 0;
        message.locationAccuracy = 0;
        message.heading = 0;
        message.altitude = 0;
        message.altitudeAccuracy = 0;
        message.speed = 0;
        message.clientTimestamp = "";
        message.properties = {};
        if (value !== undefined)
            reflectionMergePartial<PositionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PositionRequest): PositionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string position_id */ 1:
                    message.positionId = reader.string();
                    break;
                case /* string producer_id */ 2:
                    message.producerId = reader.string();
                    break;
                case /* double latitude */ 3:
                    message.latitude = reader.double();
                    break;
                case /* double longitude */ 4:
                    message.longitude = reader.double();
                    break;
                case /* float location_accuracy */ 5:
                    message.locationAccuracy = reader.float();
                    break;
                case /* float heading */ 6:
                    message.heading = reader.float();
                    break;
                case /* float altitude */ 7:
                    message.altitude = reader.float();
                    break;
                case /* float altitude_accuracy */ 8:
                    message.altitudeAccuracy = reader.float();
                    break;
                case /* float speed */ 9:
                    message.speed = reader.float();
                    break;
                case /* string client_timestamp */ 10:
                    message.clientTimestamp = reader.string();
                    break;
                case /* map<string, string> properties */ 12:
                    this.binaryReadMap12(message.properties, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap12(map: PositionRequest["properties"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof PositionRequest["properties"] | undefined, val: PositionRequest["properties"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for tpg.PositionRequest.properties");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: PositionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string position_id = 1; */
        if (message.positionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.positionId);
        /* string producer_id = 2; */
        if (message.producerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.producerId);
        /* double latitude = 3; */
        if (message.latitude !== 0)
            writer.tag(3, WireType.Bit64).double(message.latitude);
        /* double longitude = 4; */
        if (message.longitude !== 0)
            writer.tag(4, WireType.Bit64).double(message.longitude);
        /* float location_accuracy = 5; */
        if (message.locationAccuracy !== 0)
            writer.tag(5, WireType.Bit32).float(message.locationAccuracy);
        /* float heading = 6; */
        if (message.heading !== 0)
            writer.tag(6, WireType.Bit32).float(message.heading);
        /* float altitude = 7; */
        if (message.altitude !== 0)
            writer.tag(7, WireType.Bit32).float(message.altitude);
        /* float altitude_accuracy = 8; */
        if (message.altitudeAccuracy !== 0)
            writer.tag(8, WireType.Bit32).float(message.altitudeAccuracy);
        /* float speed = 9; */
        if (message.speed !== 0)
            writer.tag(9, WireType.Bit32).float(message.speed);
        /* string client_timestamp = 10; */
        if (message.clientTimestamp !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.clientTimestamp);
        /* map<string, string> properties = 12; */
        for (let k of globalThis.Object.keys(message.properties))
            writer.tag(12, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.properties[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tpg.PositionRequest
 */
export const PositionRequest = new PositionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PositionResponse$Type extends MessageType<PositionResponse> {
    constructor() {
        super("tpg.PositionResponse", [
            { no: 1, name: "position_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "producer_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "latitude", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "longitude", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "location_accuracy", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 6, name: "heading", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 7, name: "altitude", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 8, name: "altitude_accuracy", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 9, name: "speed", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 10, name: "client_timestamp", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "server_timestamp", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "properties", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } }
        ]);
    }
    create(value?: PartialMessage<PositionResponse>): PositionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.positionId = "";
        message.producerId = "";
        message.latitude = 0;
        message.longitude = 0;
        message.locationAccuracy = 0;
        message.heading = 0;
        message.altitude = 0;
        message.altitudeAccuracy = 0;
        message.speed = 0;
        message.clientTimestamp = "";
        message.serverTimestamp = "";
        message.properties = {};
        if (value !== undefined)
            reflectionMergePartial<PositionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PositionResponse): PositionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string position_id */ 1:
                    message.positionId = reader.string();
                    break;
                case /* string producer_id */ 2:
                    message.producerId = reader.string();
                    break;
                case /* double latitude */ 3:
                    message.latitude = reader.double();
                    break;
                case /* double longitude */ 4:
                    message.longitude = reader.double();
                    break;
                case /* float location_accuracy */ 5:
                    message.locationAccuracy = reader.float();
                    break;
                case /* float heading */ 6:
                    message.heading = reader.float();
                    break;
                case /* float altitude */ 7:
                    message.altitude = reader.float();
                    break;
                case /* float altitude_accuracy */ 8:
                    message.altitudeAccuracy = reader.float();
                    break;
                case /* float speed */ 9:
                    message.speed = reader.float();
                    break;
                case /* string client_timestamp */ 10:
                    message.clientTimestamp = reader.string();
                    break;
                case /* string server_timestamp */ 11:
                    message.serverTimestamp = reader.string();
                    break;
                case /* map<string, string> properties */ 12:
                    this.binaryReadMap12(message.properties, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap12(map: PositionResponse["properties"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof PositionResponse["properties"] | undefined, val: PositionResponse["properties"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for tpg.PositionResponse.properties");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: PositionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string position_id = 1; */
        if (message.positionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.positionId);
        /* string producer_id = 2; */
        if (message.producerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.producerId);
        /* double latitude = 3; */
        if (message.latitude !== 0)
            writer.tag(3, WireType.Bit64).double(message.latitude);
        /* double longitude = 4; */
        if (message.longitude !== 0)
            writer.tag(4, WireType.Bit64).double(message.longitude);
        /* float location_accuracy = 5; */
        if (message.locationAccuracy !== 0)
            writer.tag(5, WireType.Bit32).float(message.locationAccuracy);
        /* float heading = 6; */
        if (message.heading !== 0)
            writer.tag(6, WireType.Bit32).float(message.heading);
        /* float altitude = 7; */
        if (message.altitude !== 0)
            writer.tag(7, WireType.Bit32).float(message.altitude);
        /* float altitude_accuracy = 8; */
        if (message.altitudeAccuracy !== 0)
            writer.tag(8, WireType.Bit32).float(message.altitudeAccuracy);
        /* float speed = 9; */
        if (message.speed !== 0)
            writer.tag(9, WireType.Bit32).float(message.speed);
        /* string client_timestamp = 10; */
        if (message.clientTimestamp !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.clientTimestamp);
        /* string server_timestamp = 11; */
        if (message.serverTimestamp !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.serverTimestamp);
        /* map<string, string> properties = 12; */
        for (let k of globalThis.Object.keys(message.properties))
            writer.tag(12, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.properties[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tpg.PositionResponse
 */
export const PositionResponse = new PositionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkPositionRequest$Type extends MessageType<BulkPositionRequest> {
    constructor() {
        super("tpg.BulkPositionRequest", [
            { no: 1, name: "positions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PositionRequest }
        ]);
    }
    create(value?: PartialMessage<BulkPositionRequest>): BulkPositionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.positions = [];
        if (value !== undefined)
            reflectionMergePartial<BulkPositionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkPositionRequest): BulkPositionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated tpg.PositionRequest positions */ 1:
                    message.positions.push(PositionRequest.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkPositionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated tpg.PositionRequest positions = 1; */
        for (let i = 0; i < message.positions.length; i++)
            PositionRequest.internalBinaryWrite(message.positions[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tpg.BulkPositionRequest
 */
export const BulkPositionRequest = new BulkPositionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkPositionResponse$Type extends MessageType<BulkPositionResponse> {
    constructor() {
        super("tpg.BulkPositionResponse", [
            { no: 1, name: "positions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PositionResponse }
        ]);
    }
    create(value?: PartialMessage<BulkPositionResponse>): BulkPositionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.positions = [];
        if (value !== undefined)
            reflectionMergePartial<BulkPositionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkPositionResponse): BulkPositionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated tpg.PositionResponse positions */ 1:
                    message.positions.push(PositionResponse.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkPositionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated tpg.PositionResponse positions = 1; */
        for (let i = 0; i < message.positions.length; i++)
            PositionResponse.internalBinaryWrite(message.positions[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tpg.BulkPositionResponse
 */
export const BulkPositionResponse = new BulkPositionResponse$Type();
/**
 * @generated ServiceType for protobuf service tpg.Tracking
 */
export const Tracking = new ServiceType("tpg.Tracking", [
    { name: "TrackPosition", options: {}, I: PositionRequest, O: PositionResponse },
    { name: "TrackPositions", options: {}, I: BulkPositionRequest, O: BulkPositionResponse },
    { name: "AddSubscription", options: {}, I: AddSubscriptionRequest, O: SubscriptionResponse },
    { name: "RemoveSubscription", options: {}, I: RemoveSubscriptionRequest, O: SubscriptionResponse },
    { name: "Subscribe", serverStreaming: true, options: {}, I: SubscribeRequest, O: PositionResponse },
    { name: "SubscribeV2", serverStreaming: true, options: {}, I: SubscribeRequest, O: SubscribeEvent },
    { name: "Ping", options: {}, I: PingRequest, O: PongEvent },
    { name: "Pong", options: {}, I: PongEvent, O: Empty }
]);
/**
 * @generated ServiceType for protobuf service tpg.Health
 */
export const Health = new ServiceType("tpg.Health", [
    { name: "Check", options: {}, I: Empty, O: HealthCheckResponse }
]);
